export enum SaleTypeEnum {
    SALE = 'SALE',
    SALE_QUOTE = 'SALE_QUOTE',
}

export enum SaleTypeLabelEnum {
    SALE = 'Venda',
    SALE_QUOTE = 'Orçamento',
}
